import React from "react";
import API from "../../base/API";
import { translate } from "../../base/Translation";

export default class PDFButton extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            get_summary_report: "/test/pdf/report/:test",
            get_protocol_report: "/test/pdf/protocol/:test",
            get_form_report: "/test/pdf/form/:test",
        });
    }

    onGenerate() {

        let route = false;

        switch (this.props.type) {
            case "summary":
                route = "get_summary_report";
                break;
            case "protocol":
                route = "get_protocol_report";
                break;
            case "form":
                route = "get_form_report";
                break;
            default:
                route = false;
        }

        if (!route) {
            return;
        }

        this.api.request({
            cache: false,
            route: route,
            params: { test: this.props.test.id },
            success: function (response) {
                window.dispatchEvent(new Event("reloadLog"));
                window.open(response.file, '_blank');
            }
        });
    }

    render() {
        const buttonClass = "btn btn-primary btn-sm pull-right";

        return (
            <button className={buttonClass} onClick={this.onGenerate.bind(this)}>
                <i className="fa fa-file" />&nbsp; {translate("Generovať PDF")}
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/PDFButton.jsx